import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../images/homepage/CALYX_LOGO.svg";
import fbIcon from "../images/homepage/wired-outline-2540-logo-facebook-hover-pinch.png";
import instaIcon from "../images/homepage/wired-outline-2542-logo-instagram-hover-pinch.png";
import "./Navbar.css";

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="minimal-navbar">
      <div className="nav-wrapper">
        {/* LEFT: LOGO */}
        <div className="nav-logo" onClick={() => navigate("/")}>
          <img src={logo} alt="Calyx Logo" />
        </div>

        {/* CENTER: NAV LINKS */}
        <div className={`nav-links ${menuOpen ? "active" : ""}`}>
          <a href="/#home" onClick={handleNavClick}>Home</a>
          <a href="/#products" onClick={handleNavClick}>Collection</a>
          <a href="/#about" onClick={handleNavClick}>About</a>
          <a href="/#faq" onClick={handleNavClick}>FAQ</a>
          <a href="/#contact" onClick={handleNavClick}>Contact</a>
          <a href="/booking" className="booking-link" onClick={handleNavClick}>Booking</a>
        </div>

        {/* RIGHT: SOCIALS */}
        <div className="nav-right-area">
          <div className="nav-socials">
             <a href="https://facebook.com" target="_blank" rel="noreferrer"><img src={fbIcon} alt="FB" /></a>
             <a href="https://instagram.com" target="_blank" rel="noreferrer"><img src={instaIcon} alt="IG" /></a>
          </div>
        </div>

        {/* HAMBURGER MENU */}
        <button className="hamburger-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
}